const compareModalReducer = (state = false, action) => {
    switch(action.type) {
        case 'SET_COMPARE_MODAL':
            return !state;
        default:
            return state;
    }
}

export default compareModalReducer;